import React, { useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';

import { updateGuideSortKeys } from '../../redux/actors';
import { getGuideSortKeys } from '../../redux/selectors';
import { useSelector } from '../../redux';
import './guideSortButton.scss';

const DROPDOWN_ITEMS = [
{ 
  title: 'Price: Low to High',
  sortFunction: 'sortByPrice', order: 1,
},
{ 
  title: 'Price: High to Low',
  sortFunction: 'sortByPrice', order: -1,
},
{ 
  title: 'Ratings: Low to High',
  sortFunction: 'sortByAverageRating', order: 1,
},
{ 
  title: 'Ratings: High to Low',
  sortFunction: 'sortByAverageRating', order: -1,
},
{ 
  title: 'Experience: Low to High',
  sortFunction: 'sortByExperienceYears', order: 1,
},
{ 
  title: 'Experience: High to Low',
  sortFunction: 'sortByExperienceYears', order: -1,
},
];

export default function GuideSortButton() {
  const [dropdown, setDropdown] = useState(false);
  const toggleDropdown = () => setDropdown(!dropdown);

  const { sortFunction, order } = useSelector(getGuideSortKeys) || {};
  
  return (
    <Dropdown isOpen={dropdown} toggle={toggleDropdown} className="guide-sort">
      <DropdownToggle caret color="none">
        Sort By
      </DropdownToggle>
      <DropdownMenu>
        {
          DROPDOWN_ITEMS.map(item => {
            const isActive = item.sortFunction === sortFunction && item.order === order;
            const onClick = () => updateGuideSortKeys({
              order: item.order,
              sortFunction: item.sortFunction,
            });
            
            return <DropdownItem key={item.title} onClick={onClick} active={isActive}>{item.title}</DropdownItem>;
          })
        }
      </DropdownMenu>
    </Dropdown>
  );
};
